import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/skeletons/AuthorPageSkeleton.jsx");
